
<div class="sidebar" #animationMenu [hidden]="ocultoLogin" id="animationMenu">
    <div class="sidebar_logo">
        <img src="assets/imagenes/icons/icons_sidebar/logoGrande.svg" alt="Logo todomas" class="logoGrande" *ngIf="logoSidebar">
        <img src="assets/imagenes/icons/icons_sidebar/logoPequeno.svg" alt="Logo todomas" class="logoPequeno" *ngIf="!logoSidebar">
    </div>

    <div class="sidebar_modulo">
        <!-- COM Inicio -->
        <div class="modulo_opcion" (click)="redireccionamiento('inicio')">
            <div class="modulo_item" [ngClass]="moduloInicio ? 'moduloActivo' : ''">
                <img class="item_img" src="assets/imagenes/icons/icons_sidebar/homeAzul.svg" alt="" *ngIf="!homeSeleccionado">
            </div>
            <div class="modulo_texto">
                <p>1. Inicio</p>
            </div>
        </div>

        <div class="modulo_opcion" (click)="abrirSubitem('monitoreo')" *ngIf="validarOpcion(constantesOpciones.DETALLE_SUCURSALES) || validarOpcion(constantesOpciones.NUMEROS_MAS_JUGADOS)">
            <div class="modulo_item" [ngClass]="numerosJugados || detalleSucursales ? 'moduloActivo' : ''" #monitoreo>
                <img class="item_img" src="assets/imagenes/icons/icons_sidebar/monitoreoAzul.svg" alt="">
            </div>
            <div class="modulo_texto">
                <p>2. Monitoreo</p>
            </div>
            <div class="modulo_flecha">
                <img src="assets/imagenes/icons/icons_sidebar/flechaAzul.svg" alt="Flecha">
            </div>
        </div>

        <div class="contenedor_subitems animate__animated animate__fadeInLeft" *ngIf="monitoreoSeleccionado" #itemMonitoreo>
            <div class="subitem" (click)="redireccionamiento('numerosjugados')" *ngIf="validarOpcion(constantesOpciones.NUMEROS_MAS_JUGADOS)">
                <p [ngClass]="numerosJugados ? 'itemActivo' : ''">- Números jugados</p>
            </div>
            <div class="subitem" (click)="redireccionamiento('detallesucursales')" *ngIf="validarOpcion(constantesOpciones.DETALLE_SUCURSALES)">
                <p [ngClass]="detalleSucursales ? 'itemActivo' : ''">- Detalle sucursales</p>
            </div>
        </div>

        <div class="modulo_opcion" (click)="abrirSubitem('empresa')" *ngIf="validarOpcion(constantesOpciones.ADMINISTRAR_CORREOS)">
            <div class="modulo_item" [ngClass]="adminCorreos ? 'moduloActivo' : ''" #empresa>
                <img class="item_img" src="assets/imagenes/icons/icons_sidebar/empresaAzul.svg" alt="">
            </div>
            <div class="modulo_texto">
                <p>3. Empresa</p>
            </div>
            <div class="modulo_flecha">
                <img src="assets/imagenes/icons/icons_sidebar/flechaAzul.svg" alt="">
            </div>
        </div>

        <div *ngIf="empresaSeleccionado">
            <div class="contenedor_subitems animate__animated animate__fadeInLeft" *ngIf="validarOpcion(constantesOpciones.ADMINISTRAR_CORREOS)" #itemEmpresa>
                <div class="subitem" (click)="redireccionamiento('administradorcorreo')">
                    <p [ngClass]="adminCorreos ? 'itemActivo' : ''">- Administrador de correo</p>
                </div>
            </div>
        </div>

        <div class="modulo_opcion" (click)="abrirSubitem('reportes')" *ngIf="validarOpcion(constantesOpciones.INFORME_VENTA_BANCA_RECARGAS_POR_VENDEDOR) || validarOpcion(constantesOpciones.BOLETAS_VENDIDAS) || validarOpcion(constantesOpciones.BOLETAS_GANADORAS)">
            <div class="modulo_item" [ngClass]="ventaLoteriaOtros || reportePremios || reporteAnulados || boletasVendidas || boletasGanadoras || boletasAnuladas ? 'moduloActivo' : ''" #reportes>
                <img class="item_img" src="assets/imagenes/icons/icons_sidebar/reportesAzul.svg" alt="">
            </div>
            <div class="modulo_texto">
                <p>4. Reportes</p>
            </div>
            <div class="modulo_flecha">
                <img src="assets/imagenes/icons/icons_sidebar/flechaAzul.svg" alt="">
            </div>
        </div>

        <div class="contenedor_subitems animate__animated animate__fadeInLeft" *ngIf="reportesSeleccionado && (validarOpcion(constantesOpciones.INFORME_VENTA_BANCA_RECARGAS_POR_VENDEDOR) || validarOpcion(constantesOpciones.REPORTE_VENTAS_QUINTE))" #itemReportes>
            <div class="subitem" (click)="redireccionamiento('reportesVentas')">
                <p [ngClass]="ventaLoteriaOtros ? 'itemActivo' : ''">- Ventas</p>
            </div>
            <div class="subitem" (click)="redireccionamiento('reportesPremios')" *ngIf="validarOpcion(constantesOpciones.REPORTE_PREMIOS_QUINTE)">
                <p [ngClass]="reportePremios ? 'itemActivo' : ''">- Premios</p>
            </div>
            <div class="subitem" (click)="redireccionamiento('reportesAnulados')" *ngIf="validarOpcion(constantesOpciones.REPORTE_ANULADOS_QUINTE)">
                <p [ngClass]="reporteAnulados ? 'itemActivo' : ''">- Anulados</p>
            </div>
            <div class="subitem" (click)="abrirSubitem('reportesRifas')" *ngIf="validarOpcion(constantesOpciones.BOLETAS_VENDIDAS) || validarOpcion(constantesOpciones.BOLETAS_GANADORAS) || validarOpcion(constantesOpciones.BOLETAS_ANULADAS)">
                <p [ngClass]="boletasVendidas || boletasGanadoras || boletasAnuladas ? 'itemActivo' : ''">- Rifas</p>
            </div>
            <div class="contenedor_rifasSubitems animate__animated animate__fadeInLeft" *ngIf="reportesRifasSeleccionado" #subitemReporteRifas>
                <div class="rifasSubitems" (click)="redireccionamiento('boletasvendidas')" *ngIf="validarOpcion(constantesOpciones.BOLETAS_VENDIDAS)">
                    <p [ngClass]="boletasVendidas ? 'itemActivo' : ''">Boletas vendidas</p>
                </div>
                <div class="rifasSubitems" (click)="redireccionamiento('boletasganadoras')" *ngIf="validarOpcion(constantesOpciones.BOLETAS_GANADORAS)">
                    <p [ngClass]="boletasGanadoras ? 'itemActivo' : ''">Boletas ganadoras</p>
                </div>
                <div class="rifasSubitems" (click)="redireccionamiento('boletasanuladas')" *ngIf="validarOpcion(constantesOpciones.BOLETAS_ANULADAS)">
                    <p [ngClass]="boletasAnuladas ? 'itemActivo' : ''">Boletas anuladas</p>
                </div>
            </div>

        </div>

        <div class="modulo_opcion" (click)="abrirSubitem('rifas')" *ngIf="validarOpcion(constantesOpciones.REGISTRO_RIFA) || validarOpcion(constantesOpciones.REGISTRO_SORTEO)">
            <div class="modulo_item" [ngClass]="registroRifas || registroSorteos ? 'moduloActivo' : ''" #rifas>
                <img class="itemRifas_img" src="assets/imagenes/icons/icons_sidebar/rifa.svg" alt="">
            </div>
            <div class="modulo_texto">
                <p>5. Rifas</p>
            </div>
            <div class="modulo_flecha">
                <img src="assets/imagenes/icons/icons_sidebar/flechaAzul.svg" alt="">
            </div>
        </div>

        <div class="contenedor_subitems animate__animated animate__fadeInLeft" *ngIf="rifasSeleccionado " #itemRifas>
            <div class="subitem" (click)="redireccionamiento('registrorifas')" *ngIf="validarOpcion(constantesOpciones.REGISTRO_RIFA)">
                <p [ngClass]="registroRifas ? 'itemActivo' : ''">- Registro rifas</p>
            </div>
            <div class="subitem" (click)="redireccionamiento('registrosorteos')" *ngIf="validarOpcion(constantesOpciones.REGISTRO_SORTEO)">
                <p [ngClass]="registroSorteos ? 'itemActivo' : ''">- Registro sorteos</p>
            </div> 
        </div>
    </div>
</div>